<template>
    <footer class="footer has-cards">
        <div class="container container-lg">
        </div>
        <div class="container">
            <div class="row row-grid align-items-center my-md">
                <div class="col-lg-2">
                    <h3 class="text-primary font-weight-light mb-2">Follow Us!</h3>
                </div>
                <div class="col-lg-2 text-lg-center btn-wrapper">
                    <a target="_blank" rel="noopener" href="https://twitter.com/dyddoyourdance"
                       class="btn btn-neutral btn-icon-only btn-twitter btn-round btn-lg" data-toggle="tooltip"
                       data-original-title="Follow us">
                        <i class="fa fa-twitter"></i>
                    </a>
                    <a target="_blank" rel="noopener" href="https://www.facebook.com/DYDDoYOURDance/"
                       class="btn btn-neutral btn-icon-only btn-facebook btn-round btn-lg" data-toggle="tooltip"
                       data-original-title="Like us">
                        <i class="fa fa-facebook-square"></i>
                    </a>
                    <a target="_blank" rel="noopener" href="https://www.instagram.com/dyddoyourdance/"
                       class="btn btn-neutral btn-icon-only  btn-instagram btn-round btn-lg" data-toggle="tooltip"
                       data-original-title="Star on Github">
                        <i class="fa fa-instagram"></i>
                    </a>
                </div>
            </div>
            <hr>
            <div class="row align-items-center justify-content-md-between">
                <div class="col-md-6">
				
                    <ul class="nav nav-footer justify-content-end">
                        <!--<li class="nav-item">
                            <a href="/" class="nav-link" target="_blank" rel="noopener">About
                                Us</a>
                        </li>
                        <li class="nav-item">
                            <a href="/" class="nav-link" target="_blank" rel="noopener">Terms</a>
                        </li>
                        <li class="nav-item">
                            <a href="https://github.com/creativetimofficial/argon-design-system/blob/master/LICENSE.md"
                               class="nav-link" target="_blank" rel="noopener">Privacy Policy</a>
                        </li>-->
                    </ul>
                </div>
            </div>
        </div>
    </footer>
</template>
<script>
export default {
  name: 'app-footer',
  data() {
    return {
      year: new Date().getFullYear()
    }
  }
};
</script>
<style>
</style>
